<template>
    <div class="product-gallery">

        <div class="main">

            <BadgeHolder
                         :badges="badges"
                         :discount_price="discount_price"
                         :main_price="main_price"
                         :default_price="default_price"
                         :stock="stock"
                         :has_variations="has_variations"
                         :variation_values="variation_values"
                         :set_products="set_products">
            </BadgeHolder>

            <Splide :options="mainOptions" ref="mainSlider">
                <SplideSlide v-for="(image, key) in images" :key="key">
                    <figure>
                        <img :src="image"
                             loading="lazy"
                             :alt="name"
                             @click="lightboxVisible = true; imgIndex = key"
                        >
                    </figure>
                </SplideSlide>
            </Splide>
        </div>

        <div class="nav">
            <Splide :options="thumbOptions" ref="thumbSlider">
                <SplideSlide v-for="(image, key) in images" :key="key">
                    <figure>
                        <img :src="image"
                             loading="lazy"
                             :alt="name"
                        >
                    </figure>
                </SplideSlide>
            </Splide>
        </div>

        <vue-easy-lightbox
            :visible="lightboxVisible"
            :imgs="images"
            :index="imgIndex"
            @hide="lightboxVisible = false"
        ></vue-easy-lightbox>
    </div>
</template>

<script>
import { reactive, toRefs, ref, onMounted } from 'vue'
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'
import VueEasyLightbox from 'vue-easy-lightbox'
import BadgeHolder from "./templates/BadgeHolder";

export default {

    props: [
        'items',
        'badges',
        'name',
        'discount_price',
        'main_price',
        'default_price',
        'stock',
        'has_variations',
        'variation_values',
        'set_products',
    ],

    components: {
        Splide,
        SplideSlide,
        VueEasyLightbox,
        BadgeHolder
    },

    setup(props) {

        const state = reactive({
            lightboxVisible: false,
            imgIndex: 0,
            images: props.items
        })

        const mainSlider  = ref(),
             thumbSlider  = ref()

        const mainOptions = {
            arrows: false,
            pagination: false
        }

        const thumbOptions = {
            perPage: props.items.length > 4 ? 4 : props.items.length,
            isNavigation: true,
            arrows: false,
            pagination: false,
            focus: 'center',
            gap: '12px',
            breakpoints: {
                767: {
                    perPage: 3
                },
                400: {
                    perPage: 2
                }
            }
        }

        onMounted( () => {
            const thumbSplide = thumbSlider.value?.splide

            if ( thumbSplide ) mainSlider.value?.sync(thumbSplide)

            // if ( parseFloat(props.product.price) > parseFloat(props.product.main_price) ) {
            //     state.hasDiscount = true
            // }
        })

        return {
            ...toRefs(state),
            mainSlider,
            thumbSlider,
            mainOptions,
            thumbOptions
        }
    }
}
</script>
